import React from "react";
import SEO from "../components/SEO";
import { LegalPage } from "../components/LegalPage";

const SECTIONS = [
  { h: "We want to hear from you", p: [
    "If you are unhappy with any part of your care, our service or how we have handled your information, please tell us. Raising a concern will never affect the care you receive from us.",
  ] },
  { h: "How to raise a concern", list: [
    "Email enquiries@camcpc.co.uk with \"Complaint\" in the subject line, or",
    "Call +44 (0) 1223 256653 and ask to speak to the clinic manager, or",
    "Write to Cambridge Cardiovascular Prevention Clinic, ACCI Building, Cambridge University Hospitals, Hills Road, Cambridge CB2 0QQ.",
  ], after: [
    "Please tell us your name, how to contact you, and what happened. Please do not include detailed medical information in an email; we will arrange a secure way to discuss it with you. You can complain on someone else's behalf with their written consent.",
  ] },
  { h: "What happens next", list: [
    "We will acknowledge your complaint within 3 working days.",
    "A senior member of the team who was not involved will look into it, and may ask to speak with you.",
    "We aim to send you a full written response within 20 working days. If it will take longer, we will tell you why and keep you updated.",
    "Our response will explain what we found, any actions we are taking and, where appropriate, an apology.",
  ] },
  { h: "If you are not satisfied", p: [
    "If you are unhappy with our response, please let us know and we will review it again. You can also share your experience with the Care Quality Commission (cqc.org.uk, 03000 616161), which regulates health services in England.",
    "For concerns about how we use your personal information, you can contact the Information Commissioner's Office (ico.org.uk, 0303 123 1113). Our ICO registration reference is ZC286200.",
  ] },
];

export default function Complaints() {
  return (
    <>
      <SEO title="Complaints" description="How to raise a concern with Cambridge Cardiovascular Prevention Clinic and how we will handle it." path="/complaints" />
      <LegalPage testId="complaints-page" eyebrow="Complaints" title="Raising a concern." updated="October 2026" sections={SECTIONS} />
    </>
  );
}
